
import { callServer } from 'next/dist/client/app-call-server'

function __build_action__(action, args) {
  return callServer(action.$$id, args)
}

/* __next_internal_action_entry_do_not_use__ {"3dae135e22c6a62dd398a5652303bd4879efd7af":"$$ACTION_1","547afe42b9a9339b9104c08d625522bd3f2c2f9a":"SetDefaultCurrency","7817697803a83a755af081135ef11f4de8808614":"$$ACTION_0","eca1ea4558f8d7ed18b5c3a1c5f4c71cea8eaf9c":"SetDefaultContractType"} */ export var SetDefaultContractType = createServerReference("eca1ea4558f8d7ed18b5c3a1c5f4c71cea8eaf9c");
import { createServerReference } from "private-next-rsc-action-client-wrapper";
export var SetDefaultCurrency = createServerReference("547afe42b9a9339b9104c08d625522bd3f2c2f9a");

